/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Tlm_2Inputs */

const en_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`state_control`)
};

const ar_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحكم في الحالة`)
};

const bn_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`state_control`)
};

const de_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`state_control`)
};

const es_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`control_estado`)
};

const fr_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`state_control`)
};

const pt_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estado_controle`)
};

const zh_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态控制`)
};

const tr_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`state_control`)
};

const ru_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`состояние_контроля`)
};

const pl_svc_mobile_app_development_tlm_2 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kontrola_stanu`)
};

/**
* | output |
* | --- |
* | "state_control" |
*
* @param {Svc_Mobile_App_Development_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_tlm_2 = /** @type {((inputs?: Svc_Mobile_App_Development_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "de") return de_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "es") return es_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_tlm_2(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_tlm_2(inputs)
	return en_svc_mobile_app_development_tlm_2(inputs)
});
export { svc_mobile_app_development_tlm_2 as "svc_mobile-app-development_tlm_2" }